<div class="custom-scrollbar table-scroll">
  <table [dataSource]="entries" class="w100" mat-table multiTemplateDataRows>

    <ng-container matColumnDef="select">
      <th *matHeaderCellDef class="select-cell" mat-header-cell>
        <mat-checkbox (change)="toggleAll($event.checked)" [checked]="isAllSelected()"
                      [indeterminate]="isSomeSelected()" aria-label="Alle auswählen"></mat-checkbox>
      </th>
      <td *matCellDef="let entry" class="select-cell" mat-cell>
        <mat-checkbox (change)="toggle(entry, $event.checked)" (click)="$event.stopPropagation()"
                      [checked]="selection.has(entry.id)" aria-label="Eintrag auswählen"></mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="productive">
      <th *matHeaderCellDef mat-header-cell>prod.</th>
      <td *matCellDef="let entry" mat-cell>
        <span [class.table-a0]="entry.productive==='A0'" [class.table-a1]="entry.productive==='A1'"
              [class.table-a2]="entry.productive==='A2'" [class.table-all]="entry.productive==='NONE'"
              [class.table-b1]="entry.productive==='B1'" [class.table-b2]="entry.productive==='B2'"
              [class.table-c1]="entry.productive==='C1'"
              [class.table-c2]="entry.productive==='C2'">{{ level(entry.productive) }}</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="receptive">
      <th *matHeaderCellDef mat-header-cell>rez.</th>
      <td *matCellDef="let entry" mat-cell>
        <span [class.table-a0]="entry.receptive==='A0'" [class.table-a1]="entry.receptive==='A1'"
              [class.table-a2]="entry.receptive==='A2'" [class.table-all]="entry.receptive==='NONE'"
              [class.table-b1]="entry.receptive==='B1'" [class.table-b2]="entry.receptive==='B2'"
              [class.table-c1]="entry.receptive==='C1'"
              [class.table-c2]="entry.receptive==='C2'">{{ level(entry.receptive) }}</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th *matHeaderCellDef mat-header-cell>{{ nameHeader }}</th>
      <td *matCellDef="let entry" [class.bold]="expanded === entry" mat-cell>{{ entry.name }}</td>
    </ng-container>

    <ng-container matColumnDef="country">
      <th *matHeaderCellDef mat-header-cell>Variante</th>
      <td *matCellDef="let entry" mat-cell>{{ country(entry.country) }}</td>
    </ng-container>

    <ng-container matColumnDef="example">
      <th *matHeaderCellDef mat-header-cell>Beispiel</th>
      <td *matCellDef="let entry" mat-cell>{{ entry.example }}</td>
    </ng-container>

    <ng-container matColumnDef="mode">
      <th *matHeaderCellDef mat-header-cell>Modus</th>
      <td *matCellDef="let entry" mat-cell>{{ mode(entry.mode) }}</td>
    </ng-container>

    <ng-container matColumnDef="activity">
      <th *matHeaderCellDef mat-header-cell>Aktivität</th>
      <td *matCellDef="let entry" mat-cell>{{ activity(entry.activity) }}</td>
    </ng-container>

    <ng-container matColumnDef="category">
      <th *matHeaderCellDef mat-header-cell>Thema</th>
      <td *matCellDef="let entry" mat-cell>{{ entry.categoryName }}</td>
    </ng-container>

    <ng-container matColumnDef="edit">
      <th *matHeaderCellDef class="details-cell" mat-header-cell>Bearbeiten</th>
      <td *matCellDef="let entry" class="details-cell" mat-cell>
        <button (click)="editEntry(entry); $event.stopPropagation()" aria-label="Eintrag bearbeiten" color="primary"
                mat-icon-button matTooltip="Eintrag bearbeiten" matTooltipShowDelay="1000">
          <mat-icon>edit</mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="details">
      <th *matHeaderCellDef class="details-cell" mat-header-cell>Details</th>
      <td *matCellDef="let entry" class="details-cell" mat-cell>
        @if (detailService) {
          <button (click)="toggleDetails(entry); $event.stopPropagation()" aria-label="Details anzeigen"
                  mat-icon-button>
            <mat-icon>{{ expanded === entry ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
          </button>
        } @else {
          <a (click)="$event.stopPropagation()" [routerLink]="['/textmuster', entry.id]" aria-label="Textmuster öffnen"
             mat-icon-button>
            <mat-icon>open_in_new</mat-icon>
          </a>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="expandedDetail">
      <td *matCellDef="let entry" [attr.colspan]="displayedColumns.length" mat-cell>
        <div [@detailExpand]="expanded === entry ? 'expanded' : 'collapsed'" class="detail-wrapper">
          @if (expanded === entry && detailService) {
            <app-entry-details [id]="entry.id" [service]="detailService"></app-entry-details>
          }
        </div>
      </td>
    </ng-container>

    <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
    <tr (click)="detailService && toggleDetails(entry)" *matRowDef="let entry; columns: displayedColumns;"
        [class.clickable]="!!detailService" [class.expanded-row]="expanded === entry" mat-row></tr>
    <tr *matRowDef="let entry; columns: ['expandedDetail']" class="detail-row" mat-row></tr>
  </table>
</div>
